export enum Decimals {
	NONE = 0,
	ONE = 1,
	TWO = 2,
	THREE = 3
}